import { useGraphQLClient } from "graphql-client/GraphQLClientContext";

export const SubscriptionReadyMarker = () =>
  useGraphQLClient().isSocketReady ? <div id="subscription-ready" /> : null;
